<template>
  <div :class="['page-content']">
    <h2 :class="title"><span v-if="filteredIcons.length">{{ filteredIcons.length }}</span><span v-else>No</span> icon<span v-if="filteredIcons.length > 1 || !filteredIcons.length">s</span> found at
      <a :href="this.serviceData.url" :title="service" target="_blank">{{ service }}</a> <span v-if="search">for "<span v-html="search" />"</span></h2>
    <v-text-field append-icon="search" color="grey" v-model="search" :placeholder="placeholder" />
    <ul :class="['icons-list', 'inline-list', 'no-bullet-list', 'mt-3']">
      <li v-for="(icon, index) in filteredIcons" :key="icon" @click="getIcon(index)">
        <v-icon>{{ icon }}</v-icon>
        <h4 :class="caption" v-html="icon" />
      </li>
    </ul>
    <vue-adsense ad-severity="block" :ad-client="adClient" ad-slot="8182071534" ad-format="fluid" ad-layout="in-article" />
    <icon-popup ref="dialog" />
  </div>
</template>
<script>
import IconPopup from '../components/icon-popup'

export default {
  name: 'ServicePage',
  components: {
    IconPopup
  },
  data () {
    return {
      service: null,
      search: '',
      placeholder: '',
      icons: this.$store.getters.currentServiceIcons,
      title: this.$store.state.title || [],
      caption: this.$store.state.caption || [],
      adClient: this.$store.state.googleAdSenseAdClient
    }
  },
  watch: {
    '$route.params.service' () {
      this.setService()
    }
  },
  created () {
    this.setService()
  },
  computed: {
    filteredIcons () {
      return this.icons.filter(icon => {
        return icon.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  methods: {
    getIcon (index) {
      const icon = this.filteredIcons[index]
      const dialog = this.$refs['dialog']
      dialog.open = true
      dialog.icon = {
        title: icon,
        service: this.service
      }
    },
    setService () {
      this.search = ''
      this.service = this.$route.params.service
      this.serviceData = this.$store.state.services[this.service]
      this.placeholder = `search ${this.service} icons...`
      this.icons = this.$store.getters.icons[this.service]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/service.vue